import type { FaireProductEntity } from "../../entity_types/product";

export const p_3k4rkzda4h: FaireProductEntity = {
  token: "p_3k4rkzda4h",
  type: "product",
  name: "NAKAME",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.faire.com/fastly/faea1fc023d86bac5fff790e67aff583bb89685ef1061d420ab3b5923692fe12.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2f0e0498bc65b36a2df043c61713030f96897677eeb14145c546602a4e1077d1.jpeg",
    "https://cdn.faire.com/fastly/7c0fd2207a0e521fa3ec1084ee4a85f5f1ccff45aded34acb48c425f05993633.jpeg",
    "https://cdn.faire.com/fastly/e936ebf14585a86db2fca66ecfd58ec1647c6399e8e67f9492d2002c1bed5014.jpeg",
    "https://cdn.faire.com/fastly/f50fa4d67abfa9da5d01dfad7a8ff7e315a8eebc382d2e0dc0f51702878b3f84.jpeg",
    "https://cdn.faire.com/fastly/a5b059c27a22c68453e693417a59dea85dd070939b0e72d41ba82a4ab2017eac.jpeg",
  ],
  priceDollars: 24,
  description:
    "Inspired by the enchanting Nakameguro neighborhood in Tokyo, where cherry blossoms drift along the Meguro River and the streets pulse with a cool, creative energy. By night, lanterns glow, trees illuminate, and the riverfront transforms into a pathway of ethereal beauty.\n\nwhisked matcha, shiso, flowering yoshino, yuzu lime, chilled sake\n\n\nWe collaborated on this collection with the incredibly talented Tokyo-based artist Keisuke Shoda, founder of Studio The Blue Boy. Known for his playful aesthetic that blends traditional Japanese style with a modern, whimsical twist, his artwork beautifully captures the essence of some of our favorite parts of Japan.\n\nThese beautiful hand-painted ceramics are designed to be re-loved and reused.\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn. We use lead-free cotton wicks and premium fragrance oils. All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials. \n\n8 ounces (226g), comes in our signature Japan Collection box.\n\n\n",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T13:49:23.956Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
